<template>
    <div class="va-app" :class="isSigninRoute()">
        <navigation></navigation>

        <div class="va-container">
            <div class="va-content">
                <router-view></router-view>
            </div>
            <page-footer></page-footer>
        </div>
    </div>
</template>

<script>
import Navigation from './pageLayout/Navigation.vue'
import Footer from './pageLayout/Footer.vue'

export default {
    data() {
        return {}
    },
    methods: {
        isSigninRoute() {
            return this.$route.name === 'signin' ? 'va-app-signin-screen' : ''
        }
    },
    components: {
        navigation: Navigation,
        'page-footer': Footer
    }
}
</script>
